/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';

import accountActions from 'loraactions/account';
import orgActions from 'loraactions/org';
import usageActions from 'loraactions/usage';
import billingActions from 'loraactions/billing';

const defaultProps = {
  children: null,
  authed: false,
};

const propTypes = {
  children: React.PropTypes.any,
  authed: React.PropTypes.bool,
  gotoLogin: React.PropTypes.func.isRequired,
  getAccountBasic: React.PropTypes.func.isRequired,
  getOrgBasic: React.PropTypes.func.isRequired,
  getGatewaysUsage: React.PropTypes.func.isRequired,
  getAppsUsage: React.PropTypes.func.isRequired,
  getNodesUsage: React.PropTypes.func.isRequired,
  getPlan: React.PropTypes.func.isRequired,
};

class AuthLatch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.checkAuth();
    this.loadGlobalInfos();
  }

  componentWillReceiveProps(nextProps) {
    this.checkAuth(nextProps);
    if (nextProps.authed && !this.props.authed) {
      this.loadGlobalInfos();
    }
  }

  checkAuth(props = this.props) {
    const { authed } = props;
    const { gotoLogin } = this.props;
    if (!authed) {
      gotoLogin();
    }
  }

  loadGlobalInfos() {
    const {
      authed,
      getAccountBasic,
      getOrgBasic,
      getGatewaysUsage,
      getAppsUsage,
      getNodesUsage,
      getPlan,
    } = this.props;
    if (authed) {
      getAccountBasic();
      getOrgBasic();
      getGatewaysUsage();
      getAppsUsage();
      getNodesUsage();
      getPlan();
    }
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

AuthLatch.defaultProps = defaultProps;
AuthLatch.propTypes = propTypes;

const mapStateToProps = state => ({
  authed: state.auth.authed,
});

const mapDispatchToProps = dispatch => ({
  gotoLogin: () => dispatch(replace('/login')),
  getAccountBasic: () => dispatch(accountActions.basic()),
  getOrgBasic: () => dispatch(orgActions.basic()),
  getAppsUsage: () => dispatch(usageActions.apps()),
  getGatewaysUsage: () => dispatch(usageActions.gateways()),
  getNodesUsage: () => dispatch(usageActions.nodes()),
  getPlan: () => dispatch(billingActions.plan()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthLatch);




// WEBPACK FOOTER //
// ./src/containers/AuthLatch.jsx